



















import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
// import { DtFormItem } from "src/components";

type Size = 'small' | 'medium' | 'large';

interface InputConfig {
  name?: string,
  size?: Size,
  disabled?: boolean,
  readonly?: boolean,
  placeholder?: string,
  label?: string,
  key?: string,
  inline?: boolean,
  tip?: string,
  validators?: any,
  valueFormat?: string,
  pickerOptions?: any
}


@Component({
  name: 'mcTimepicker',
  components: {
    // DtFormItem
  }
})
export default class extends Vue {
  @Prop({ default: () => [] }) private value!: string | undefined;
  @Prop({ default: () => [] }) private config?: any;
  currentValue: string = this.value;
  private defaultConfig: any = {
    size: 'medium'
  };

  // 合并默认数据
  get currentConfig() {
    const result = this.config;
    Object.keys(this.defaultConfig).forEach((key: string) => {
      if (this.config[key] === undefined) result[key] = this.defaultConfig[key];
    });
    return result;
  }

  // 检测值
  @Watch("value")
  onValueChanged(val: string) {
    this.currentValue = val;
  }

  /**
   * 输入框值改变
   * @author JieShuai
   * @param value 值
   */
  @Emit('on-change')
  handleChange(value: string) {
    this.$emit('input', value);
  }

  /**
   * 失去焦点事件
   * @author JieShuai
   * @param any event 事件
   */
  handleBlur(event: any) {
    this.$emit('on-blur', event);
  }

  /**
   * 使input 获取焦点
   * @author tanxj
   * @param any event 事件
   */
  handleFocus(event: any) {
    this.$emit('on-focus', event);
  }
}
